import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=aaae805a&scoped=true"
import script from "./baseInfo.vue?vue&type=script&lang=js"
export * from "./baseInfo.vue?vue&type=script&lang=js"
import style0 from "./baseInfo.vue?vue&type=style&index=0&id=aaae805a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaae805a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaae805a')) {
      api.createRecord('aaae805a', component.options)
    } else {
      api.reload('aaae805a', component.options)
    }
    module.hot.accept("./baseInfo.vue?vue&type=template&id=aaae805a&scoped=true", function () {
      api.rerender('aaae805a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/baseInfo.vue"
export default component.exports